export default location.origin.indexOf('github.io') !== -1



// WEBPACK FOOTER //
// ./src/utils/isOnline.js